import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';
import '@aws-amplify/ui-react/styles.css';

// Components
import CustomAuth from './components/CustomAuth';

// Pages
import QNavDashboard from './pages/QNavDashboard';
import NotFound from './pages/NotFound';
import DesignSystem from './pages/DesignSystem';

// Contexts
import { AuthContext } from './contexts/AuthContext';

// Types
interface User {
  username: string;
  attributes: {
    email: string;
    sub: string;
    [key: string]: any;
  };
}

function App() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    checkUser();
  }, []);

  async function checkUser() {
    try {
      const currentUser = await getCurrentUser();
      setUser(currentUser as any);
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-aws-deepblue">
        <div className="qnav-loading-spinner border-aws-orange"></div>
      </div>
    );
  }

  return (
    <CustomAuth>
      {({ signOut, user: authUser }) => {
        // Use the user from CustomAuth instead of local state
        const contextUser = authUser || user;
        return (
          <AuthContext.Provider
            value={{
              user: contextUser,
              setUser,
              isAuthenticated: !!contextUser,
              isLoading: loading,
            }}
          >
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard/*" element={<QNavDashboard signOut={signOut || (() => {})} />} />
              <Route path="/design-system" element={<DesignSystem />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthContext.Provider>
        );
      }}
    </CustomAuth>
  );
}

export default App;
